import * as React from 'react';
import { ReactComponent as MenuThreePointsSvg } from '../../assets/icons/mevo/ic-menu-three-points.svg';
import IconPattern, { IconProps } from './_IconPattern';

const MenuThreePointsIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={MenuThreePointsSvg} variantPlaces={2} {...props} />;
};

export default MenuThreePointsIcon;
